var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTree2 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 57.89 155.57",
    style: {
      enableBackground: "new 0 0 57.89 155.57"
    },
    xmlSpace: "preserve",
    overflow: "visible",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.t20{fill:#D4D3D7;}\n\t.t21{fill:#6C401D;}\n\t.t22{fill:#09A959;}\n\t.t23{fill:#068C45;}\n\t.st0{transform-origin: 50% 50%; transform-box: fill-box;}\n\t.st1{transform-origin: 50% 100%; transform-box: fill-box;}\n\t.st2{transform-origin: 50% 100%; transform-box: fill-box;}\n\t.st3{transform-origin: 50% 100%; transform-box: fill-box;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0 t20",
    cx: 28.95,
    cy: 151.85,
    rx: 19.6,
    ry: 3.72
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.44,
    y: 139.63,
    className: "st1 t21",
    width: 9,
    height: 12.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2 t22",
    d: "M57.89,96.39c0,38.87-12.96,44.39-28.94,44.39S0,135.26,0,96.39S19.74,0,28.95,0 C37.87,0,57.89,57.51,57.89,96.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3 t23",
    d: "M28.95,0c-0.19,0-0.37,0.03-0.56,0.07v140.7c0.19,0,0.37,0.01,0.56,0.01c15.98,0,28.94-5.51,28.94-44.39 S37.87,0,28.95,0z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTree2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tree2.a34df50c5b8e29987ed3f03dc0eb6d1b.svg";